module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/laboral/laboral.component.css
// module id = ./src/app/components/laboral/laboral.component.css
// module chunks = main